import { useContext, useEffect, useRef, useState } from "react";
import PrimaryNavigation from "./PrimaryNavigation";
import AlertsFlyout from "./AlertsFlyout";
import { ClientConfigurationContext } from "../context/ClientConfigurationContextProvider";

export default function Header({ alerts, innerRef, embedded }) {
    const clientConfiguration = useContext(ClientConfigurationContext);
    const [showFlyout, setShowFlyout] = useState(false);
    const [localAlerts, setLocalAlerts] = useState([]);

    const flyoutRef = useRef();

    function setAlertLoading(alertId, isLoading) {
        setLocalAlerts((prev) => {
            if (!Array.isArray(prev)) return prev;
            return prev.map((a) => {
                if (a?.id !== alertId) return a;
                const data = a?.data || {};
                return { ...a, data: { ...data, isLoading } };
            });
        });
    }

    useEffect(() => {
        if (clientConfiguration?.enableAlerts) {
            setLocalAlerts(alerts ?? []);
        }
    }, [alerts, clientConfiguration]);


    function openFlyout() {
        setShowFlyout(true);
        setTimeout(() => {
            if (flyoutRef.current) {
                flyoutRef.current.setAttribute("expanded", "");
            }
        }, 0);
    }

    function closeFlyout() {
        if (flyoutRef.current) {
            flyoutRef.current.removeAttribute("expanded");
        }
        setShowFlyout(false);
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if (flyoutRef.current && !flyoutRef.current.contains(event.target) && showFlyout) {
                closeFlyout();
            }
        }
        if (showFlyout) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showFlyout]);

    const showAlerts = clientConfiguration?.enableAlerts && localAlerts?.length > 0;
    const showHeaderBar = !embedded || showAlerts;

    return (
        <>
            <a data-onboarding-link-id="Header:SkipToMainContent" className="skip-to-content" href="#wrapper">Skip to main content</a>
            {showHeaderBar && (
                <header id="primary-header" role="banner" ref={innerRef}>
                    {!embedded && (
                        <div className="header-logo">
                            <a data-onboarding-link-id="Header:Home" href="/"><span className="icon-geico" aria-label="GEICO Home" /></a>
                        </div>
                    )}
                    {embedded && showAlerts && (
                        <div className="header-logo" aria-hidden="true" />
                    )}

                    <div className="header-links">
                        <ul>
                            {showAlerts &&
                                <li>
                                    <gds-icon-button data-onboarding-button-id="Header:OpenAlerts" onClick={openFlyout} icon-type="alert" notification>
                                        {`${localAlerts.length} Alert${localAlerts.length > 1 ? 's' : ''}`}
                                    </gds-icon-button>
                                </li>
                            }
                            {!embedded && (
                                <li>
                                    <a data-onboarding-link-id="Header:OpenMenu" data-side-panel-trigger="menu" className="hamburger-menu" href="/">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span className="header-link">Menu</span>
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
                </header>
            )}
            {!embedded && <PrimaryNavigation />}
            {clientConfiguration?.enableAlerts && showFlyout &&
                <AlertsFlyout flyoutRef={flyoutRef} alerts={localAlerts} onClose={closeFlyout} onSetAlertLoading={setAlertLoading} />
            }
        </>
    );
};
